import { IOrderBy, Meta } from "src/@types/paginated";

export const getPagesToShow = (meta: Meta) => {
  const pages = [];
  const { currentPage = 0, lastPage = 0 } = meta;

  if (lastPage <= 5) {
    for (let i = 1; i <= lastPage; i++) {
      pages.push(i);
    }
  } else {
    pages.push(1);

    let startPage = Math.max(2, currentPage - 1);
    let endPage = Math.min(lastPage - 1, currentPage + 1);

    if (currentPage <= 3) {
      endPage = 4;
    } else if (currentPage >= lastPage - 2) {
      startPage = lastPage - 3;
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    if (endPage < lastPage - 1) {
      pages.push("...");
    }

    pages.push(lastPage);
  }

  if (!pages.length) {
    pages.push(1);
  }
  return pages;
};

export const handeOrderBy = (order: IOrderBy) => {
  let orderBy: IOrderBy = { id: "asc" };
  if (order && Object.values(order)?.every((value) => value && value !== "")) {
    orderBy = order;
  }
  return orderBy;
};
